import axios from 'axios'
import { Message } from 'element-ui'
import { checkSign } from '@/utils/auth'
import { removeToken, removeCookie } from '@/utils/auth'

// 创建 axios 实例
const service = axios.create({
  // baseURL: '/api', // api 的 base_url
  //baseURL: 'https://ct.vbaymax.com', // api 的 base_url
   baseURL: 'https://charging.whzkc.com',
  //baseURL: 'http://192.168.126.81:8000', // api 的 base_url
  timeout: 60000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
    if (!config.type) {
      config = checkSign(config)
    }
    return config
  },
  error => {
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data

    if (res.code === 90003 || res.code === 5003) {
      removeToken()
      removeCookie()
      window.location.href = '/#/login'
      return
    }

    if (res.code === 90004) {
      Message({
        message:  res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      return
    }

    // if (res.code !== 0 && res.code != 30001) {
    //   Message({
    //     message: res.msg,
    //     type: 'warning',
    //     duration: 5 * 1000
    //   })
    //   Promise.reject(res.msg)
    // } else {
    return {
      ...response.data,
      other: response.config
    }
    //}
  },
  error => {
    if (error.code === 'ECONNABORTED') {
      Message({
        message: '服务器连接超时,请稍后重试',
        type: 'error',
        duration: 5 * 1000
      })
    } else {
      if (error.config) {
        Message({
          message: '接口访问失败，请联系管理员修复',
          type: 'error',
          duration: 5 * 1000
        })
      }
    }
    return Promise.reject(error)
  }
)

export default service
